import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=62c15375&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputLabel: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/inputs/InputLabel.vue').default})
